query CompanyUserOccupationTitles {
  companyUserOccupationTitles(
    orderBy: USER_OCCUPATION_TITLE_BY_USER_OCCUPATION_TITLE_ID__USER_OCCUPATION_TITLE_ASC
  ) {
    nodes {
      userOccupationTitleId
      userOccupationTitles {
        userOccupationTitle
      }
    }
  }
}

